import { Api } from 'models/services/api';
import { UpdateOriginalIngredientCategoryQuery } from 'models/services/graphql';

import { OriginalIngredientCategoryData, OriginalIngredientCategoryDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: OriginalIngredientCategoryDataToSave;
};

const RequestQuery = `
  mutation UpdateOriginalIngredientCategory($id: ID!, $input: OriginalIngredientCategoryInput!) {
    ${UpdateOriginalIngredientCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    updateOriginalIngredientCategory: OriginalIngredientCategoryData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: OriginalIngredientCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateOriginalIngredientCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };